import { defineMessages } from 'react-intl';

export default defineMessages({
    totalFees: {
        id: 'ml.quoteandbind.common.state-fees.totalFees',
        defaultMessage: 'Total fees: '
    },
    includedInPremium: {
        id: 'ml.quoteandbind.common.state-fees.includedInPremium',
        defaultMessage: '(included in premium)'
    },
    feeDetails: {
        id: 'ml.quoteandbind.common.state-fees.feeDetails',
        defaultMessage: 'Fee Details'
    }
});
